import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[telephone]',
    standalone: false
})
export class TelephoneDirective {
	inputElement: HTMLInputElement;

	constructor(private el: ElementRef) {
		this.inputElement = el.nativeElement;
	}

	@HostListener('blur', ['$event']) onBlur($event): void {
		const value: string = this.inputElement.value;
		if (!value) {
			return;
		}

		// Convert the number to a string
		const strNumber: string = value.toString();

		// Format the phone number as "01 85 96 74 52"
		const formattedNumber: string = strNumber.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
		$event.target.value = formattedNumber;
	}

	@HostListener('focus', ['$event']) onFocus($event) {
		$event.target.value = this.inputElement.value?.replace(/\s/g, '');
	}
}
